import React, { Component } from 'react'
import Axios from 'axios'
let axios = Axios.create()

export default class ButtonArchivoPUC extends Component {
    constructor(props) {
        super(props);
        this.state = {
            'logs': this.props.indicator.logs
        }

        this.enviarArchivo = this.enviarArchivo.bind(this);
    }

    enviarArchivo() {
        if(confirm("Desea enviar archivo TXT a servidor?") == true){
            axios.get(`/api/inventario/archivo-final/${this.props.indicator.indicator.id_file}/archivoTXT`)
                .then(({data, status}) => {
                    if(status == 200){
                        this.setState({
                            'logs': this.state.logs.concat(data)
                        });
                    }
            }).catch((error) => {
                console.log(error);
            });
        }
    }

    componentWillReceiveProps(nextProps){
        if(nextProps !== this.props && nextProps.indicator.logs.length > 0){
            this.setState({
                'logs': nextProps.indicator.logs
            });
        }
    }

    render() {
        return this.props.indicator.indicator.id_file
            ? this.state.logs.length > 0
                ? <button onClick={this.enviarArchivo} className='btn btn-success btn-xs'
                    title='Enviar archivo TXT'
                >
                    <span className="glyphicon glyphicon-export"></span>
                </button>
                : <button onClick={this.enviarArchivo} className='btn btn-danger btn-xs'
                    title='Enviar archivo TXT'
                >
                    <span className="glyphicon glyphicon-export"></span>
                </button>

            : <button disabled className='btn btn-warning btn-xs'
                title='Enviar archivo TXT'
            >
                <span className="glyphicon glyphicon-export"></span>
            </button>
    }
}


// WEBPACK FOOTER //
// ./frontEnd/home/components/ButtonArchivoPUC.jsx